<template>
  <div ref="EinapageInstallation" class="transparent">
    <p>{{ $t('portfolio.einaPage.installation.descriptionLabel') }}</p>
    <einapage-instance />

    <h2>{{ $t('portfolio.einaPage.installation.introduction.title') }}</h2>
    <hr class="secondary">
    <p>{{ $t('portfolio.einaPage.installation.introduction.paragraph') }}</p>

    <h2>{{ $t('portfolio.npmPackages.versioning.title') }}</h2>
    <hr class="secondary">
    <p>
      {{ $t('portfolio.npmPackages.versioning.paragraph') }}
      <a
        href="https://semver.org/spec/v2.0.0.html"
        class="general-anchor decorated"
        rel="noreferrer,noopener"
        target="_blank"
      >
        <span>semver</span>
      </a>.
    </p>

    <h2>{{ $t('portfolio.npmPackages.license.title') }}</h2>
    <hr class="secondary">
    <p>{{ $t('portfolio.npmPackages.license.paragraph') }}</p>

    <h2>{{ $t('portfolio.npmPackages.preRequisites') }}</h2>
    <hr class="secondary">
    <ul>
      <li>Node 10+</li>
      <li>NPM 6+</li>
      <li>Vue 2.5.17+</li>
    </ul>

    <h2>{{ $t('portfolio.npmPackages.installation') }}</h2>
    <hr class="secondary">
    <pre v-highlight class="highlight">
      <code>
npm install --save einapage-vue
      </code>
    </pre>
  </div>
</template>

<script>
const EinapageInstance = () => import(/* webpackChunkName: "EinapageInstance" */ '@/components/Portfolio/EinapageInstance');

export default {
  name: 'EinapageInstallation',
  components: {
    EinapageInstance
  }
};
</script>
